import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import * as Converter from "../converter";
import { RESERVATION_LIST_BY_RESERVATION_ID_FOR_MANAGEMENT_RESERVATION_SEARCH_QUERY } from "../schema";

type Props = {
	queryVariables?: {
		hotelID: string;
		reservationId: string;
	};
};

export const useReservationListByReservationIDQuery = ({ queryVariables }: Props) => {
	const { data } = useCustomSuspenseQuery(
		RESERVATION_LIST_BY_RESERVATION_ID_FOR_MANAGEMENT_RESERVATION_SEARCH_QUERY,
		queryVariables ? { variables: queryVariables } : undefined,
		queryVariables === undefined, // skipToken = true
	);

	const { queryData } = Converter.useReservationListByReservationIDQueryData({ serverData: data });

	return {
		queryData,
	};
};
